import React from "react";

function Footer({ children }) {
  return (
    <>
      <tfoot className="text-xs font-medium text-gray-700 bg-gray-100 border-t border-line-strong dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600">
        {children}
      </tfoot>
    </>
  );
}

Footer.displayName = "Table.Footer";

export default Footer;
